import styled, { css } from 'styled-components';

// Import styles
import { flex, media } from 'components/styles';
import { applyStyleModifiers } from 'styled-components-modifiers';

const CHECKBOX_MODIFIERS = {
	primary: ({ theme, checked }) => css`
		width: 1.8rem;
		height: 1.8rem;
		border: 1.5px solid
			${checked
				? theme.personalData.form.checkbox.borderChecked
				: theme.personalData.form.checkbox.border};

		background-color: ${checked
			? theme.personalData.form.checkbox.backgroundColor
			: 'none'};
		svg {
			width: 1.4rem;
			height: 1.4rem;
		}
	`
};

const CHECKBOX_WRAPPER_MODIFIERS = {
	primary: () => css`
		p {
			margin-left: 0;
			color: grey;
			cursor: pointer;
		}
	`
};

export const Wrapper = styled.div`
	margin-bottom: 1.5rem;
	${media.min.medium(css`
		margin-bottom: 3rem;
	`)}
`;

export const CheckboxWrapper = styled.label`
	display: flex;

	p {
		margin-left: 1.2rem;
		width: 100%;
		font-size: 1.4rem;
		font-weight: ${({ theme }) => theme.font.normal};
		${media.min.small(css`
			max-width: 65rem;
		`)}
		${media.min.medium(css`
			width: 68.3rem;
			max-width: auto;
			font-weight: ${({ theme }) => theme.font.medium};
		`)}
		line-height: 1.68rem;
		color: ${({ theme }) => theme.graySoft};
	}

	${applyStyleModifiers(CHECKBOX_WRAPPER_MODIFIERS)}
`;

export const FormError = styled.span`
	display: block;
	margin-top: 1rem;
	font-size: 1.2rem;
	color: ${({ theme }) => theme.red};
	text-align: left;
	padding-left: 0.7rem;
`;

export const CheckboxHidden = styled.input`
	display: none;
`;

export const CheckboxStyled = styled.span`
	width: 1.8rem;
	height: 1.8rem;
	margin-right: 0.5rem;
	border: 1.5px solid
		${({ theme }) => theme.authentication.agreements.checkboxBorderColor};
	border-radius: 2px;
	cursor: pointer;
	${flex()};

	svg {
		opacity: ${({ checked }) => (checked ? 1 : 0)};
		visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
		width: 1rem;
		height: 0.7rem;

		polyline {
			stroke: ${({ theme }) =>
				theme.authentication.agreements.checkboxIconColor};
		}
	}

	${applyStyleModifiers(CHECKBOX_MODIFIERS)}
`;
